import { createFileRoute } from '@tanstack/react-router';

import { getDoctoralCommitteeOptions } from '@/module/Author/DoctoralCommittee';

export const Route = createFileRoute(
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout',
)({
  loader: async ({ params: { doctoralCommitteeId }, context: { queryClient } }) => {
    const doctoralCommittee = await queryClient.ensureQueryData(getDoctoralCommitteeOptions(doctoralCommitteeId));

    return {
      doctoralCommittee,
      crumb: doctoralCommittee.candidateName,
    };
  },
});
